export const PUBLIC = 'PUBLIC';
export const RESTRICTED = 'RESTRICTED';

const hasText = (override) => Boolean(override.title || override.description);

// Which generic consequences of a scope change towards `target` apply to the current override rows.
export const scopeChangeConsequences = (overrides, target) => {
    const withText = overrides.filter(hasText);
    const withoutText = overrides.filter((o) => !hasText(o));

    return target === RESTRICTED
        ? {
              textsKeptWithoutAccess: withText.length > 0,
              hiddenRemoved: withoutText.some((o) => o.visible === false),
              listedRemoved: withoutText.some((o) => o.visible !== false),
          }
        : {
              authorizedTextsKept: withText.some((o) => o.visible === true),
              textsNowVisible: withText.some((o) => o.visible !== true),
              authorizedListedWithoutOverride: withoutText.length > 0,
          };
};

// Count shown in the scope badge: every row when public, the authorized rows when restricted.
export const scopeCount = (overrides, visibility) =>
    visibility === RESTRICTED ? overrides.filter((o) => o.visible === true).length : overrides.length;
